import { render, staticRenderFns } from "./BackListing.vue?vue&type=template&id=bd8c5fd2&"
import script from "./BackListing.vue?vue&type=script&lang=js&"
export * from "./BackListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports